<div class="prime-card lottie-file-parent" @fadeSlideInUp>
    <img class="prime-card-glow-top" src="assets/svg/icons/glow.svg" />
    <web-celebration
        *ngIf="!showSimmer"
        [filePath]="lottie.celebration"
        class="lottie-file lottie-file-w40"
    ></web-celebration>
    <main class="prime-card-body lottie-file-overlay">
        <div class="body-content">
            <span class="icon card-icon-center" svgIcon="assets/svg/icons/badge-success-gbs.svg"></span>
            <h3 class="card-title-gradient">Payment Successful</h3>

            <div class="prime-subcard--secondary">
                <web-table-shimmer [rowCount]="5" *ngIf="showSimmer"></web-table-shimmer>

                <table class="info-table label-uppercase" *ngIf="!showSimmer">
                    <tbody>
                        <tr>
                            <td>Loan Account Number</td>
                            <td>{{ txnDetails?.applicationId || "" }}</td>
                        </tr>
                        <tr>
                            <td>Amount Paid</td>
                            <td>
                                {{
                                    txnDetails?.amt || 0 | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>Payment mode</td>
                            <td>{{ txnDetails?.paymentType || "" }}</td>
                        </tr>
                        <tr>
                            <td>
                                {{ txnDetails?.transfer?.key || "" }}
                            </td>
                            <td>{{ txnDetails?.transfer?.value || "" }}</td>
                        </tr>
                        <tr>
                            <td>Date & Time</td>
                            <td>
                                {{ txnDetails?.transactionDate || "" | customDateFormat: "DD MMM YYYY, hh:mm A" }}
                            </td>
                        </tr>
                        <tr>
                            <td>Payment ID</td>
                            <td>{{ txnDetails?.bankTxn || "" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ng-container *ngIf="rewardPointMsg?.title">
                <h3 class="fs-3xl primary-gradient-text mt-10 mt-auto">{{ rewardPointMsg?.title }}</h3>
                <p class="fs-base text-primary-50">{{ rewardPointMsg?.subTitle }}</p>
            </ng-container>
        </div>
    </main>
    <div class="prime-card-footer">
        <div class="prime-card-footer-right">
            <button
                *ngIf="nocPdf"
                type="button"
                class="primary-outline-btn"
                [disabled]="isDownloadSummary || isDownloadNoc || showSimmer"
                (click)="downloadPdf(nocPdf, 'Noc_')"
            >
                <span *ngIf="isDownloadNoc">Downloading...<web-spinner></web-spinner> </span>
                <span *ngIf="!isDownloadNoc">Download NOC Letter</span>
            </button>
            <button
                type="button"
                class="primary-outline-btn"
                [disabled]="isDownloadSummary || isDownloadNoc || showSimmer"
                (click)="downloadSummary()"
            >
                <span *ngIf="isDownloadSummary">Downloading...<web-spinner></web-spinner> </span>
                <span *ngIf="!isDownloadSummary">Download Receipt</span>
            </button>
            <button
                type="button"
                [disabled]="showSimmer || isDownloadSummary || isDownloadNoc"
                class="primary-fill-btn"
                (click)="submit()"
            >
                Back to Dashboard
            </button>
        </div>
    </div>
</div>
